import type { SVGProps } from 'react';

export const Eye = (props: SVGProps<SVGSVGElement>) => (
    <svg fill='currentColor' xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' {...props}>
        <path d='M22.79 11.44C19.57 7.23 15.84 5 12 5S4.43 7.23 1.21 11.44l-.47.61.47.61C4.43 16.81 8.16 19 12 19s7.57-2.19 10.79-6.33l.47-.61-.47-.62zM12 17c-3.01 0-6.02-1.71-8.72-4.96C5.98 8.74 8.99 7 12 7s6.02 1.74 8.72 5.04C18.02 15.29 15.01 17 12 17z' />
        <circle cx='12' cy='12' r='3' />
    </svg>
);
